import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

class GoldSilverService {
  async getGraphData(
    city: string,
    interval: string,
    metal: string
  ): Promise<number[][]> {
    return await fetch(
      `${publicRuntimeConfig.CLEARTAX_DOMAIN}/f/gold-silver/price-graph/?city=${city}&interval=${interval}&metal=${metal}`
    )
      .then((res) => res.json())
      .then((data) => data)
      .catch((err) => console.log('Error fetching GRAPH DATA', err));
  }
}

export default new GoldSilverService();
